import { render, staticRenderFns } from "./post.vue?vue&type=template&id=ea8d65b8"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/forge/ab.farescraper.com/components/AppHeader.vue').default,BlogPostShare: require('/home/forge/ab.farescraper.com/components/BlogPostShare.vue').default,BlogBreadcrumbs: require('/home/forge/ab.farescraper.com/components/BlogBreadcrumbs.vue').default,AppSearchForm: require('/home/forge/ab.farescraper.com/components/AppSearchForm.vue').default,BlogPostImage: require('/home/forge/ab.farescraper.com/components/BlogPostImage.vue').default,BlogAuthorSign: require('/home/forge/ab.farescraper.com/components/BlogAuthorSign.vue').default,GoogleAdSense: require('/home/forge/ab.farescraper.com/components/GoogleAdSense.vue').default,BlogAuthorBio: require('/home/forge/ab.farescraper.com/components/BlogAuthorBio.vue').default,BlogFooter: require('/home/forge/ab.farescraper.com/components/BlogFooter.vue').default,BlogPost: require('/home/forge/ab.farescraper.com/components/BlogPost.vue').default,AppFooter: require('/home/forge/ab.farescraper.com/components/AppFooter.vue').default})
